export const sortThreadsByLatest = threads => {
  return [...threads].sort((a, b) => (b.latestMessageTimestamp || b.startedAt) - (a.latestMessageTimestamp || a.startedAt));
};